import { ICustomizations } from './providers/types'
import { loadListingsSm } from './Widget'
import { IEventAttributes, pushEvent } from './Events'

const FLIP_CARD_STYLES = `
.sellwild-flip-container {
  perspective: 1000px;
}
.sellwild-flip-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transform-style: preserve-3d;
}
.sellwild-flip-container.flipped .sellwild-flip-inner {
  transform: rotateY(180deg);
}
@media (prefers-reduced-motion: reduce) {
  .sellwild-flip-inner {
    transition: none;
  }
}
.sellwild-flip-container.flipped .sellwild-flip-front {
  pointer-events: none;
}
.sellwild-flip-container:not(.flipped) .sellwild-flip-back {
  pointer-events: none;
}
.sellwild-flip-front,
.sellwild-flip-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  border-radius: 12px;
  overflow: hidden;
}
.sellwild-flip-front {
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
}
.sellwild-flip-back {
  transform: rotateY(180deg);
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sellwild-flip-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.sellwild-flip-icon {
  width: 36px;
  height: 36px;
  background: rgba(255,255,255,0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sellwild-flip-icon svg {
  width: 22px;
  height: 22px;
  fill: #fff;
}
.sellwild-flip-header-text h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #fff;
}
.sellwild-flip-header-text p {
  margin: 2px 0 0;
  font-size: 13px;
  opacity: 0.9;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #fff;
}
.sellwild-flip-images {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  flex: 1;
  min-height: 0;
  border-radius: 8px;
  overflow: hidden;
}
.sellwild-flip-images img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: rgba(255,255,255,0.1);
}
.sellwild-flip-cta {
  margin-top: 12px;
  display: flex;
  justify-content: center;
}
.sellwild-flip-cta-btn {
  background: rgba(255,255,255,0.25);
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  display: flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  cursor: pointer;
}
.sellwild-flip-cta-btn svg {
  width: 16px;
  height: 16px;
}
.sellwild-flip-ad {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sellwild-flip-container.sellwild-flip-banner .sellwild-flip-front {
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;
  gap: 12px;
}
.sellwild-flip-banner .sellwild-flip-header {
  margin-bottom: 0;
  flex-shrink: 0;
}
.sellwild-flip-banner .sellwild-flip-icon {
  width: 28px;
  height: 28px;
}
.sellwild-flip-banner .sellwild-flip-icon svg {
  width: 16px;
  height: 16px;
}
.sellwild-flip-banner .sellwild-flip-header-text h3 {
  font-size: 15px;
}
.sellwild-flip-banner .sellwild-flip-header-text p {
  font-size: 11px;
}
.sellwild-flip-banner .sellwild-flip-images {
  grid-template-columns: repeat(4, 1fr);
  flex: 1;
  border-radius: 6px;
  gap: 3px;
}
.sellwild-flip-banner .sellwild-flip-cta {
  margin-top: 0;
  flex-shrink: 0;
}
.sellwild-flip-banner .sellwild-flip-cta-btn {
  padding: 6px 14px;
  font-size: 12px;
  gap: 4px;
}
.sellwild-flip-banner .sellwild-flip-cta-btn svg {
  width: 12px;
  height: 12px;
}
.sellwild-flip-banner .sellwild-flip-front,
.sellwild-flip-banner .sellwild-flip-back {
  border-radius: 8px;
}
.sellwild-flip-banner.flipped .sellwild-flip-inner {
  transform: rotateX(180deg);
}
.sellwild-flip-banner .sellwild-flip-back {
  transform: rotateX(180deg);
}
`

let stylesInjected = false
function injectStyles() {
  if (stylesInjected) return
  stylesInjected = true
  const style = document.createElement('style')
  style.textContent = FLIP_CARD_STYLES
  document.head.appendChild(style)
}

const shoppingBagSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6-2c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2zm6 16H6V8h2v2c0 .55.45 1 1 1s1-.45 1-1V8h4v2c0 .55.45 1 1 1s1-.45 1-1V8h2v12z"/></svg>`

const sparkleSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff"><path d="M12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61z"/></svg>`

const AUTO_FLIP_INTERVAL = 5000

/**
 * Walk up ancestors to find the nearest scrollable element
 */
function findScrollParent(el: Element): Element | Window {
  let current = el.parentElement
  while (current) {
    const style = getComputedStyle(current)
    const overflow = style.overflow + style.overflowY
    if (/(auto|scroll)/.test(overflow)) {
      return current
    }
    current = current.parentElement
  }
  return window
}

/**
 * Scroll to the nearest sellwild-widget on the page
 */
function scrollToWidget(fromEl: Element): boolean {
  const widget = document.querySelector('sellwild-widget')
  if (!widget) return false

  const scrollParent = findScrollParent(fromEl)

  if (scrollParent === window) {
    widget.scrollIntoView({ behavior: 'smooth', block: 'center' })
  } else {
    // For overflow containers, calculate offset and scroll manually
    const container = scrollParent as Element
    const containerRect = container.getBoundingClientRect()
    const widgetRect = widget.getBoundingClientRect()
    const offset = widgetRect.top - containerRect.top + container.scrollTop - (containerRect.height / 2) + (widgetRect.height / 2)
    container.scrollTo({ top: offset, behavior: 'smooth' })
  }
  return true
}

function darkenColor(hex: string, amount: number): string {
  const c = hex.replace('#', '')
  const num = parseInt(c.length === 3 ? c.split('').map(x => x + x).join('') : c, 16)
  const r = Math.max(0, (num >> 16) - amount)
  const g = Math.max(0, ((num >> 8) & 0x00FF) - amount)
  const b = Math.max(0, (num & 0x0000FF) - amount)
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`
}

export function generateFlipCard(
  adTag: string,
  width: number,
  height: number,
  color: string,
  partnerCode?: string,
) {
  injectStyles()
  const id = `sellwild-flip-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`
  const isBanner = width / height > 3
  const bannerClass = isBanner ? ' sellwild-flip-banner' : ''
  const imageCount = isBanner ? 4 : 2
  const placeholders = Array(imageCount)
    .fill('<div style="background:rgba(255,255,255,0.1);border-radius:4px;"></div>')
    .join('')

  const marketplaceUrl = partnerCode
    ? `https://sellwild.com/?p=${partnerCode}`
    : 'https://sellwild.com/'

  return `
    <div id="${id}" class="sellwild-flip-container${bannerClass}" style="width:${width}px;height:${height}px;display:inline-block;" data-flip-image-count="${imageCount}">
      <div class="sellwild-flip-inner">
        <div class="sellwild-flip-front" style="background:linear-gradient(135deg, ${color} 0%, ${darkenColor(color, 20)} 100%)">
          <div class="sellwild-flip-header">
            <div class="sellwild-flip-icon">${shoppingBagSvg}</div>
            <div class="sellwild-flip-header-text">
              <h3>Marketplace</h3>
              <p>Hot deals available</p>
            </div>
          </div>
          <div class="sellwild-flip-images" data-flip-images="true">
            ${placeholders}
          </div>
          <div class="sellwild-flip-cta">
            <a class="sellwild-flip-cta-btn" href="${marketplaceUrl}" target="_blank" rel="noopener noreferrer nofollow sponsored">${sparkleSvg} View marketplace</a>
          </div>
        </div>
        <div class="sellwild-flip-back">
          <div class="sellwild-flip-ad">${adTag}</div>
        </div>
      </div>
    </div>
  `
}

export function initFlipCard(
  container: Element,
  theme: ICustomizations,
  attributes: IEventAttributes,
) {
  const flipContainer = container.querySelector('.sellwild-flip-container')!
  if (!flipContainer) return

  let flipTimer: ReturnType<typeof setInterval> | null = null
  let hovered = false

  function toggle() {
    flipContainer.classList.toggle('flipped')
  }

  function startTimer() {
    if (flipTimer) return
    flipTimer = setInterval(() => {
      if (!hovered) toggle()
    }, AUTO_FLIP_INTERVAL)
  }

  function stopTimer() {
    if (flipTimer) {
      clearInterval(flipTimer)
      flipTimer = null
    }
  }

  // Load listing images for the front
  const imageCount = Number(flipContainer.getAttribute('data-flip-image-count')) || 2
  loadListingsSm(theme).then(({ listings }) => {
    const imageGrid = flipContainer.querySelector('[data-flip-images]')
    if (!imageGrid || !listings.length) return

    const visible = listings
      .filter(l => l.photos && l.photos.length > 0)
      .slice(0, imageCount)

    imageGrid.innerHTML = visible
      .map(l => {
        const imgUrl = l.photos[0].url || l.photos[0].thumbUrl
        return `<img src="${imgUrl}" alt="Marketplace item" loading="lazy" data-listing-id="${l.id}" />`
      })
      .join('')
  }).catch(() => {})

  // Hover pauses flipping, unhover resumes
  flipContainer.addEventListener('mouseenter', () => {
    hovered = true
  })

  flipContainer.addEventListener('mouseleave', () => {
    hovered = false
  })

  // Click marketplace side → image goes to listing detail, otherwise scroll to widget or open Sellwild
  const qs = `p=${theme.partnerCode}&utm_source=${theme.partnerCode}`
  const front = flipContainer.querySelector('.sellwild-flip-front')
  const marketplaceUrl = `https://sellwild.com/?p=${theme.partnerCode}`

  flipContainer.querySelector('.sellwild-flip-cta-btn')?.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    pushEvent({ event: 'flipCardMarketplaceClick', attributes })
    window.open(marketplaceUrl, '_blank', 'noopener,noreferrer')
  })

  if (front) {
    front.addEventListener('click', (e) => {
      const target = e.target as HTMLElement
      if (target.closest('.sellwild-flip-cta')) {
        return
      }
      const listingEl = target.closest('[data-listing-id]') as HTMLElement | null
      const listingId = listingEl?.getAttribute('data-listing-id')
      if (listingId) {
        pushEvent({ event: 'flipCardListingClick', label: listingId, attributes })
        window.open(`https://sellwild.com/product/${listingId}?${qs}`, '_blank')
        return
      }

      pushEvent({ event: 'flipCardMarketplaceClick', attributes })
      if (!scrollToWidget(flipContainer)) {
        window.open(marketplaceUrl, '_blank')
      }
    })
  }

  // Start auto-flip cycle
  startTimer()
}
